import create from 'zustand';

export interface BizState {
  commentId: string;
  changeCommentId: (biz: string) => void;
  reFetchReply?: () => void;
  reFetchComment?: () => void;
}

// 获取业务线 服务商  or 开发者
export const useComment = create<BizState>(set => ({
  changeCommentId: commentId => set(state => ({ ...state, commentId })),
  commentId: '',
}));

export default useComment;
